import { IEntity } from '../../../stores/nluDataStore'
import { IMessage } from '../../../types/messages'

export enum MessageDropdownActions {
    SET_INTENT = 'setIntent',
    SET_ENTITY = 'setEntity',
}

interface IReducerState {
    message: IMessage
}

interface ISetIntentAction {
    type: MessageDropdownActions.SET_INTENT
    payload: string
}

interface ISetEntityAction {
    type: MessageDropdownActions.SET_ENTITY
    payload: IEntity[]
}

type typeAction = ISetIntentAction | ISetEntityAction

function messageDropdownReducer(state: IReducerState, action: typeAction) {
    switch (action.type) {
        case MessageDropdownActions.SET_INTENT:
            return { message: { ...state.message, intent: action.payload } }
        case MessageDropdownActions.SET_ENTITY:
            return { message: { ...state.message, entities: action.payload } }
        default:
            throw new Error()
    }
}

export default messageDropdownReducer
